import FeatureList from './FeatureList';
import Logger from '../../common/logger';

const FeatureCommands = {
    find: (features, currentSiteUrl) => {
        const joinOptions = (feature, siteFeatureOptions) => {
            if (feature && feature.options && siteFeatureOptions) {
                return {
                    ...feature.options,
                    ...siteFeatureOptions
                };
            } else if (!feature || !feature.options) {
                return siteFeatureOptions;
            } else {
                return feature.options;
            }
        };

        const matchedSite = features.sites.find(s => currentSiteUrl.match(s.url));
        if (matchedSite) {
            matchedSite.features.forEach(f => {
                const options = joinOptions(
                    features.features.find(ftr => ftr.name === f.name),
                    f.options
                );
                FeatureCommands.process(f.name, options);
            });
        }
    },
    process: (feature, options, callbacks) => {
        if (!options) {
            Logger.error(
                `FeatureCommands.find: no options for ${feature} feature`
            );
            return;
        }
        const featureFound = FeatureList.find(f => f.name === feature);
        if (featureFound) {
            if (featureFound.logic && featureFound.logic.init) {
                featureFound.logic.init(options, callbacks);
                Logger.log(
                    `FeatureCommands.process: loading feature '${feature}' with options: ${JSON.stringify(
                        options
                    )}.`
                );
            }
        } else {
            Logger.error(`FeatureCommands.process: ${feature} NOT found!`);
        }
    },
    runCommand: (feature, command, options) => {
        const featureFound = FeatureList.find(f => f.name === feature);
        if (featureFound) {
            if (featureFound.logic && featureFound.logic[command]) {
                featureFound.logic[command](options);
            }
        } else {
            Logger.error(`FeatureCommands.runCommand: ${feature} NOT found!`);
        }
    }
};

export default FeatureCommands;
